import { render, staticRenderFns } from "./CardMedia.vue?vue&type=template&id=7edbd23a&scoped=true"
import script from "./CardMedia.vue?vue&type=script&lang=js"
export * from "./CardMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_3gvhbgb4yg4a32yudvtfqrrcqq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edbd23a",
  null
  
)

export default component.exports